module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_8004.f319cbf5.png";